import { darkTheme } from '../../theme/tokens';

const t = darkTheme;

export function ChatUserBubble({ text }: { text: string }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 16,
      }}
      data-testid="chat-user-bubble"
    >
      <div
        style={{
          maxWidth: '80%',
          background: t.blueBg,
          border: `1px solid ${t.blue}`,
          borderRadius: 12,
          padding: '10px 14px',
          color: t.text,
          fontSize: 14,
          lineHeight: 1.55,
          whiteSpace: 'pre-wrap',
        }}
      >
        {text}
      </div>
    </div>
  );
}
